module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Display3-d32104c4f005bb3316c4558aa5c0ac87.svg";